import { PropsWithChildren } from "react";

import { Tabs } from "@design-system/Tabs/Tabs";

import { routes } from "@pages/routes";

type Props = PropsWithChildren<{
  clientId: string;
  clientApplicationId: string;
}>;

export const ClientApplicationTabs = ({
  clientId,
  clientApplicationId,
}: Props) => {
  return (
    <Tabs>
      <Tabs.Tab
        name="Dashboard"
        to={routes.portal.clients.client.applications.application.dashboard.$buildPath(
          {
            params: { clientId, applicationId: clientApplicationId },
          },
        )}
      />
      <Tabs.Tab
        name="Record"
        to={routes.portal.clients.client.applications.application.record.$buildPath(
          {
            params: { clientId, applicationId: clientApplicationId },
          },
        )}
      />
      <Tabs.Tab
        name="Users"
        to={routes.portal.clients.client.applications.application.users.$buildPath(
          {
            params: { clientId, applicationId: clientApplicationId },
          },
        )}
      />
    </Tabs>
  );
};
